import { AnnouncementsEffects } from './announcements';
import { NewsEffects } from './news';
import { OffersEffects } from './offers';

export * from './announcements';
export * from './news';
export * from './offers';

export const NEWS_EFFECTS = [AnnouncementsEffects, NewsEffects, OffersEffects];
